import { createFileRoute } from '@tanstack/react-router';

/**
 * The root address, and nothing behind it (refonte modulaire spec §5.1).
 *
 * The common welcome page, the two access words, the team roster, the draw
 * between variants and the recruitment caps are gone. A person now enters by a
 * LINK that carries a non-guessable secret, and that link either starts a
 * session directly or opens a choice page - neither of which lives here.
 *
 * So this address keeps a screen rather than a redirect: an operator or a
 * person who lands on the bare domain has to be told what happened, and a 404
 * or a bounce to `/admin` would tell them something false. The page is
 * deliberately inert - no button, no form, no query - because there is nothing
 * to do here and offering a control would be inviting a dead end.
 *
 * The logo above it comes from `__root.tsx`, the shell of every public screen.
 */

export const Route = createFileRoute('/')({
  component: HomePage,
});

function HomePage() {
  return (
    <section className="max-w-2xl space-y-3">
      <h1 className="font-bold text-3xl text-bleu-nuit">Extraction de matière première</h1>
      <p className="text-gray-700">
        Aucune expérience n’est ouverte à cette adresse. Une invitation vous donne un lien.
      </p>
    </section>
  );
}
